import { gt } from 'ramda';

/**
 * Central lock used to prevent user refresh (QUserQuery) while long-running
 * user actions are in progress.
 *
 * Usage contract:
 * - Any component starting a long operation that can be interrupted by a
 *   user refresh must call beginUserRefreshBlock() before the operation.
 * - The returned release function must always be called on completion/cleanup.
 * - The release function is idempotent and can safely be called multiple times.
 */
let activeLockCount = 0;

export const beginUserRefreshBlock = () => {
  activeLockCount += 1;

  let hasBeenReleased = false;
  return () => {
    if (hasBeenReleased) return;
    hasBeenReleased = true;
    activeLockCount = Math.max(0, activeLockCount - 1);
  };
};

export const isUserRefreshBlocked = () => gt(activeLockCount, 0);
